/**
 * Publishes the fixed header's measured heights as CSS variables on :root.
 *
 * - `--app-navbar-height`: the logo bar. Camera layers use it to sit below it.
 * - `--app-banner-height`: the connection banner, while it shows. It is pinned over the logo bar, so
 *   no page moves for it.
 *
 * More than one Navbar can be mounted at once (a page that renders its own over the global one), so
 * each part keeps the tallest live instance and drops out when the last one unmounts.
 */
const parts = { navbar: new Map(), banner: new Map() };

const tallest = (instances) => Math.max(0, ...instances.values());

const setOrClear = (name, px) => {
    const { style } = document.documentElement;
    if (px > 0) style.setProperty(name, `${px}px`);
    else style.removeProperty(name);
};

const write = () => {
    const navbar = tallest(parts.navbar);
    const banner = tallest(parts.banner);

    setOrClear('--app-navbar-height', navbar);
    setOrClear('--app-banner-height', banner);
};

/**
 * @param {'navbar'|'banner'} part
 * @param {object} instance  identity of the mounted element
 * @param {number|null} height  `null` once it unmounts
 */
export const reportHeaderPart = (part, instance, height) => {
    if (height == null) parts[part].delete(instance);
    else parts[part].set(instance, height);
    write();
};
